import { observer } from "mobx-react-lite"
import { Checkbox } from "@mantine/core"
import React from "react"
import { ArticleStore } from "../../app/store/ArticleStore"

// ----------------------------------------------------------------------

export const ArticlePublishedCheckbox = observer(function ArticlePublishedCheckbox() {
  const { toggleType, publishedOnly, isLoading } = ArticleStore

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => toggleType(event.currentTarget.checked)

  return <Checkbox label="Только опубликованные" checked={publishedOnly} onChange={onChange} disabled={isLoading}/>
})
